export const isIOS = /(iPhone|iPod|iPad)/i.test(
  navigator.userAgentData?.platform || navigator.platform,
);

export const isMacOS = /(Mac)/i.test(
  navigator.userAgentData?.platform || navigator.platform,
);
